$(function () {
  var $alert = $(".errors ul li");

  // アラートがない場合は何もしない
  if ($alert.length == 0) {
    return;
  }

  // アラートにメールアドレスが含まれている場合、メール未認証アラートであるとする
  var pattern = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;
  if ($alert.text().match(pattern)) {
    // スタイルをあてるためにクラスをつける
    $alert.addClass("is-activation-required");
  }
});
